import heroAsset from "@/assets/auburn-hero-slider.jpg.asset.json";
import storyDetailAsset from "@/assets/auburn-pond-poppies.jpg.asset.json";
import { optimizedImages } from "@/data/optimized-images";
import siteBackinAsset from "@/assets/auburn-resort-aerial.jpg.asset.json";
import siteAccessibleAsset from "@/assets/auburn-ada-site.png.asset.json";
import advHikeAsset from "@/assets/auburn-adv-hike.jpg.asset.json";
import advRideAsset from "@/assets/auburn-adv-ride.jpg.asset.json";
import advExploreAsset from "@/assets/auburn-adv-explore.jpg.asset.json";
import advSipAsset from "@/assets/auburn-adv-sip.jpg.asset.json";
import advEscapeAsset from "@/assets/auburn-adv-escape.jpg.asset.json";
import advRaftingAsset from "@/assets/auburn-adv-rafting.jpg.asset.json";
import accommodationsAsset from "@/assets/auburn-accommodations.jpg.asset.json";
import slider4Asset from "@/assets/auburn-slider-4.jpg.asset.json";
import ctaDuskAsset from "@/assets/auburn-resort-aerial-2.jpg.asset.json";
import amenityPetsAsset from "@/assets/auburn-dog-park.jpg.asset.json";
import amenityOutdoorAsset from "@/assets/auburn-bbq-grill.jpg.asset.json";
import amenityLaundryAsset from "@/assets/auburn-laundry.jpg.asset.json";
import amenityHookupsAsset from "@/assets/auburn-rv-site.jpg.asset.json";
import amenityBathhouseAsset from "@/assets/auburn-bathhouse.webp.asset.json";
import galleryCampgroundAsset from "@/assets/auburn-campground-aerial.jpg.asset.json";
import gallerySignAsset from "@/assets/auburn-gallery-sign.jpg.asset.json";
import galleryStoreAsset from "@/assets/auburn-gallery-store.jpg.asset.json";
import galleryPicnicAsset from "@/assets/auburn-picnic-table.webp.asset.json";
import galleryClubhouseAsset from "@/assets/auburn-clubhouse.jpg.asset.json";
import galleryBathhouseAsset from "@/assets/auburn-bathhouse.webp.asset.json";
import resortMapAsset from "@/assets/auburn-resort-map.jpg.asset.json";

const advHike = advHikeAsset.url;
const advRide = advRideAsset.url;
const advExplore = advExploreAsset.url;
const advSip = advSipAsset.url;
const advEscape = advEscapeAsset.url;
const advRafting = advRaftingAsset.url;

export const images = {
  heroResort: optimizedImages.heroResort.src,
  heroSlider: heroAsset.url,
  storyMain: optimizedImages.storyMain.src,
  storyDetail: storyDetailAsset.url,
  sitePullthrough: optimizedImages.sitePullthrough.src,
  siteBackin: siteBackinAsset.url,
  siteAccessible: siteAccessibleAsset.url,
  advHike,
  advRide,
  advExplore,
  advSip,
  advRafting,
  advEscape,
  accommodations: accommodationsAsset.url,
  slider4: slider4Asset.url,
  clubhouse: galleryClubhouseAsset.url,
  campgroundAerial: galleryCampgroundAsset.url,
  ctaDusk: ctaDuskAsset.url,
  amenityPets: amenityPetsAsset.url,
  amenityOutdoor: amenityOutdoorAsset.url,
  amenityLaundry: amenityLaundryAsset.url,
  amenityHookups: amenityHookupsAsset.url,
  amenityBathhouse: amenityBathhouseAsset.url,
  /** Official Auburn RV Resort map (local optimized copies also in /public/images) */
  resortMap: resortMapAsset.url,
  resortMapPreview: "/images/auburn-rv-resort-map-preview.jpg",
  resortMapFull: "/images/auburn-rv-resort-map.jpg",
};

export const resort = {
  name: "Auburn RV Resort",
  city: "Auburn",
  region: "Sierra Foothills",
  phone: "530-889-8878",
  phoneHref: "tel:5308898878",
  email: "auburnrvresort@gmail.com",
  address: {
    street: "14400 Musso Road",
    city: "Auburn",
    state: "CA",
    zip: "95603",
  },
  tagline: "Stay Comfortable. Explore Wild.",
  directionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=14400+Musso+Road%2C+Auburn%2C+CA+95603",
  mapsEmbedUrl:
    "https://www.google.com/maps?q=14400+Musso+Road,+Auburn,+CA+95603&output=embed",
};

/** Contact used on the availability-request / reservations experience */
export const reservationContact = {
  phone: "530-889-8878",
  phoneHref: "tel:5308898878",
  email: "auburnrvresort@gmail.com",
  emailHref: "mailto:auburnrvresort@gmail.com",
  adminRecipient: "info@auburnrvresort.com",
  adminRecipients: [
    "info@auburnrvresort.com",
    "ricardo@sepub.com",
    "auburnrvresort@gmail.com",
    "bdbrewster84@gmail.com",
  ],
};

export const nav = [
  { label: "Stay", href: "/accommodations/" },
  { label: "Amenities", href: "/amenities/" },
  { label: "Explore", href: "/nearby-attractions/" },
  { label: "Rates", href: "/rates/" },
  { label: "Map", href: "/auburn-rv-map/" },
  { label: "Contact", href: "/contact-us/" },
];

export const trustItems = [
  "71 RV Sites",
  "Full Hookups",
  "Big Rig Friendly",
  "20 / 30 / 50 AMP",
  "Pet Friendly",
];

export const stats = [
  { value: 71, suffix: "", label: "RV Sites" },
  { value: 120, suffix: " FT", label: "Sites Up To" },
  { value: 50, suffix: " AMP", label: "Service Available" },
  { text: "Daily / Weekly / Monthly", label: "Stay Options" },
];

export const siteTypes = [
  {
    id: "pull-through",
    kicker: "Pull-Through Sites",
    headline: "Easy In. Easy Out.",
    copy: "Big-rig-friendly RV sites designed for convenience, with full hookups and spacious layouts.",
    cta: "Explore Pull-Through Sites",
    href: "/accommodations/#pull-through",
    image: images.sitePullthrough,
    imageSet: optimizedImages.sitePullthrough,
    alt: "Spacious pull-through RV site at Auburn RV Resort with a gravel pad and picnic area",
  },
  {
    id: "back-in",
    kicker: "Back-In Sites",
    headline: "Settle In & Stay Awhile.",
    copy: "Comfortable full-hookup sites designed for daily, weekly and extended stays.",
    cta: "Explore Back-In Sites",
    href: "/accommodations/#back-in",
    image: images.siteBackin,
    alt: "Aerial view of the resort grounds and landscaped RV sites at Auburn RV Resort",
  },
  {
    id: "accessible",
    kicker: "Accessible Sites",
    headline: "Comfort Without Compromise.",
    copy: "Accessible sites with convenient layouts and full hookup services.",
    cta: "View Accessible Sites",
    href: "/accommodations/#accessible",
    image: images.siteAccessible,
    alt: "Accessible RV site with a wide asphalt pad and smooth access at Auburn RV Resort",
  },
];

export type AmenityIcon = "hookups" | "wifi" | "laundry" | "pets" | "outdoors" | "grill";

export const amenities: {
  id: string;
  title: string;
  copy: string;
  icon: AmenityIcon;
  image?: string;
  alt?: string;
  span: string;
}[] = [
  {
    id: "hookups",
    title: "Full Hookups",
    copy: "Water, sewer and 20/30/50 amp electrical service.",
    icon: "hookups",
    span: "",
  },
  {
    id: "wifi",
    title: "Stay Connected",
    copy: "Complimentary Wi-Fi throughout the resort.",
    icon: "wifi",
    span: "",
  },
  {
    id: "laundry",
    title: "Freshen Up",
    copy: "On-site laundry, bath and shower facilities.",
    icon: "laundry",
    span: "",
  },
  {
    id: "pets",
    title: "Pet Friendly",
    copy: "Fenced dog park and convenient dog wash station.",
    icon: "pets",
    span: "",
  },
  {
    id: "outdoors",
    title: "Outdoor Spaces",
    copy: "Picnic areas for relaxing outside.",
    icon: "outdoors",
    span: "",
  },
  {
    id: "grill",
    title: "Fire Up The Grill",
    copy: "Dedicated BBQ areas for outdoor meals.",
    icon: "grill",
    span: "",
  },
];

export const adventurePanels = [
  {
    id: "explore",
    word: "Explore",
    sub: "California Gold Country",
    image: advExplore,
    alt: "Historic brick storefronts on a Gold Country main street in Auburn, California",
  },
  {
    id: "sip",
    word: "Sip",
    sub: "Sierra Foothill Wine Country",
    image: advSip,
    alt: "Wine glasses on a wooden table overlooking Sierra foothill vineyard rows at sunset",
  },
  {
    id: "escape",
    word: "Escape",
    sub: "Northern California Day Trips",
    image: advEscape,
    alt: "Clear alpine lake ringed by pines beneath Sierra Nevada granite peaks",
  },
];

export const activityCategories = [
  "All",
  "Outdoors",
  "Trails",
  "History",
  "Food & Wine",
  "Day Trips",
] as const;

export const activities = [
  {
    id: "confluence",
    name: "Auburn State Recreation Area",
    category: "Outdoors",
    copy: "Forty thousand acres along the North and Middle Forks of the American River.",
    distance: "Nearby — minutes from the resort",
    image: advHike,
    alt: "Sunlit canyon trail above the American River near Auburn",
  },
  {
    id: "westernstates",
    name: "Western States Trail",
    category: "Trails",
    copy: "Legendary foothill singletrack for hikers, runners and riders.",
    distance: "Short drive",
    image: advRide,
    alt: "Foothill singletrack trail winding through golden grasses",
  },
  {
    id: "oldtown",
    name: "Old Town Auburn",
    category: "History",
    copy: "Gold Rush architecture, local shops and long-running restaurants.",
    distance: "Short drive",
    image: advExplore,
    alt: "Historic Old Town Auburn street with brick buildings",
  },
  {
    id: "wine",
    name: "Placer County Wine Trail",
    category: "Food & Wine",
    copy: "Small family wineries tucked into the foothills around Auburn.",
    distance: "Short drive",
    image: advSip,
    alt: "Vineyard rows and oak trees in the Sierra foothills",
  },
  {
    id: "tahoe",
    name: "Lake Tahoe & the High Sierra",
    category: "Day Trips",
    copy: "An easy interstate run east into alpine lakes and granite peaks.",
    distance: "Day trip",
    image: advEscape,
    alt: "Alpine lake with granite peaks in the Sierra Nevada",
  },
  {
    id: "rafting",
    name: "American River Rafting",
    category: "Outdoors",
    copy: "Guided and self-guided runs on classic Northern California whitewater.",
    distance: "Nearby",
    image: advRafting,
    alt: "Whitewater rushing through the American River canyon",
  },
];

export const galleryCategories = ["All", "Resort", "Amenities"] as const;

export const gallery = [
  {
    id: "g6",
    src: gallerySignAsset.url,
    alt: "Rustic wooden welcome sign at Auburn RV Resort entrance",
    category: "Resort",
    span: "",
    ratio: "aspect-[4/3]",
  },
  {
    id: "g8",
    src: galleryPicnicAsset.url,
    alt: "Picnic table and landscaped RV site at Auburn RV Resort",
    category: "Amenities",
    span: "",
    ratio: "aspect-[4/3]",
  },
  {
    id: "g10",
    src: galleryStoreAsset.url,
    alt: "Auburn RV Resort office and store front with accessible parking",
    category: "Resort",
    span: "",
    ratio: "aspect-[4/3]",
  },
];

export const rates = [
  {
    id: "daily",
    label: "Daily",
    from: "$85",
    copy: "Perfect for overnight stays, road trips and short Auburn adventures.",
    cta: "Check Availability",
    action: "reserve" as const,
  },
  {
    id: "weekly",
    label: "Weekly",
    from: "$504",
    copy: "Stay longer and give yourself more time to explore Northern California.",
    cta: "Check Availability",
    action: "reserve" as const,
    featured: true,
  },
  {
    id: "monthly",
    label: "Monthly",
    from: "$1,260",
    copy: "A comfortable home base for extended stays in the Sierra Foothills.",
    cta: "Explore Extended Stays",
    action: "link" as const,
    href: "/rates/",
  },
];

export const reviews = [
  {
    id: "r1",
    rating: 5,
    quote:
      "We went to Auburn to attend a memorial of a dear friend & past employer of 32 years. I have to say that staying at the Auburn RV Resort took a large part of the cloud away. This park is so nice, quiet & so clean from the grounds to the restrooms. There was a chipmunk running around across the road putting on a great show, we also seen a large jackrabbit just like the ones we see out in the desert in Arizona, it hopped past the space we were staying in. It was an enjoyable stay, thank you management you are doing a wonderful job. If we are ever back in the area Auburn RV Resort will be our spot to stay.",
    name: "Lewis Webb",
    source: "Google Review",
  },
  {
    id: "r2",
    rating: 5,
    quote:
      "I had an amazing stay here, the staff and other campers were friendly. It is a very clean resort, nice laundry area and an overall beautiful park. It's fairly quiet being as close as it is the freeway, other than the periodic trains going by. I had no issues with the staff, reserving a site, or my stay overall. They had no issues with my dog staying weekends with me, a medium sized German shepherd.",
    name: "Jarret",
    source: "Google Review",
  },
  {
    id: "r3",
    rating: 5,
    quote:
      "We stayed here for a week in October. Beautiful park! Everything was so clean and well maintained. We will definitely stay here again. We have family in the area.",
    name: "Wendy",
    source: "Google Review",
  },
];

export const faqs = [
  {
    q: "Do you offer full hookups?",
    a: "Yes. Sites include water, sewer and electrical service with 20, 30 and 50 amp options.",
  },
  {
    q: "Are your sites big-rig friendly?",
    a: "We offer spacious sites, including options that can accommodate larger rigs. Contact the resort to confirm the best fit for your setup.",
  },
  {
    q: "Do you have pull-through RV sites?",
    a: "Yes. Pull-through sites are available for easy arrival and departure with full hookups.",
  },
  {
    q: "Is Auburn RV Resort pet friendly?",
    a: "Absolutely. There is a fenced dog park and a dog wash station on site.",
  },
  {
    q: "Do you offer monthly stays?",
    a: "Yes. Daily, weekly and monthly stays are available. Reach out for current monthly availability.",
  },
  {
    q: "Is Wi-Fi available?",
    a: "Complimentary Wi-Fi is available throughout the resort.",
  },
  {
    q: "Do you offer 50-amp electrical service?",
    a: "Yes. 20, 30 and 50 amp electrical service is available.",
  },
  {
    q: "What time is check-in?",
    a: "Check-in is at 2:00 PM. Contact the resort if you expect a late arrival.",
  },
  {
    q: "What time is check-out?",
    a: "Check-out is at 12:00 PM. Ask the front desk about late check-out availability.",
  },
  {
    q: "What attractions are close to Auburn RV Resort?",
    a: "Auburn State Recreation Area, the American River, historic Old Town Auburn, foothill trails, local wineries and Sierra Nevada day trips are all within reach.",
  },
];

export const footerColumns = [
  {
    title: "Stay",
    links: [
      { label: "RV Sites", href: "/accommodations/" },
      { label: "Rates", href: "/rates/" },
      { label: "Extended Stay", href: "/rates/" },
      { label: "Availability", href: "/reservations/" },
    ],
  },
  {
    title: "Explore",
    links: [
      { label: "Amenities", href: "/amenities/" },
      { label: "Gallery", href: "/#gallery" },
      { label: "Things To Do", href: "/nearby-attractions/" },
      { label: "Resort Map", href: "/auburn-rv-map/" },
    ],
  },
  {
    title: "Information",
    links: [
      { label: "FAQ", href: "/#faq" },
      { label: "Policies", href: "/rates/" },
      { label: "Contact", href: "/contact-us/" },
      { label: "Directions", href: "/contact-us/" },
    ],
  },
];

export const accommodationQuickFacts = [
  { value: 71, suffix: "", label: "Total RV Sites" },
  { value: 10, suffix: "", label: "Pull-Through Sites" },
  { value: 120, suffix: " FT", label: "Sites Up To" },
  { text: "50 AMP", label: "Available" },
  { text: "FULL HOOKUPS", label: "At Every Site" },
];

export type SiteIncludeIcon = "water" | "sewer" | "power" | "wifi" | "picnic" | "stays";

export const siteIncludes: {
  id: string;
  title: string;
  copy: string;
  icon: SiteIncludeIcon;
}[] = [
  {
    id: "water",
    title: "Water",
    copy: "Water connection at every RV site.",
    icon: "water",
  },
  {
    id: "sewer",
    title: "Sewer",
    copy: "Full sewer hookup.",
    icon: "sewer",
  },
  {
    id: "power",
    title: "20 / 30 / 50 Amp",
    copy: "Multiple electrical service options.",
    icon: "power",
  },
  {
    id: "wifi",
    title: "WiFi",
    copy: "Complimentary WiFi.",
    icon: "wifi",
  },
  {
    id: "picnic",
    title: "Picnic Table",
    copy: "Personal outdoor space beside your RV.",
    icon: "picnic",
  },
  {
    id: "stays",
    title: "Flexible Stays",
    copy: "Daily, weekly and monthly stay options.",
    icon: "stays",
  },
];

export const accommodationFaqs = [
  {
    q: "How many RV sites does Auburn RV Resort have?",
    a: "Auburn RV Resort offers 71 RV sites in a variety of sizes, including 10 pull-through spaces.",
  },
  {
    q: "How long are the RV sites?",
    a: "Site lengths vary significantly, from approximately 36 feet to more than 120 feet depending on the site type.",
  },
  {
    q: "Do you have pull-through sites?",
    a: "Yes. Auburn RV Resort has 10 pull-through sites ranging from approximately 44 feet to 120 feet in length.",
  },
  {
    q: "Are your sites big-rig friendly?",
    a: "Many of the resort's sites range from approximately 44 feet to 120 feet and may accommodate larger rigs. Guests traveling with large RVs should contact the resort to confirm the best available site.",
  },
  {
    q: "Do all sites have full hookups?",
    a: "Yes. RV sites include water, sewer and 20/30/50 amp electrical service.",
  },
  {
    q: "Is WiFi included?",
    a: "Yes. Complimentary WiFi is available.",
  },
  {
    q: "Can I stay weekly or monthly?",
    a: "Yes. Pull-through, back-in and accessible sites are available for daily, weekly and monthly stays, subject to availability.",
  },
  {
    q: "Is electricity included with extended stays?",
    a: "Electrical usage is metered for guests staying 60 days or longer.",
  },
  {
    q: "Are accessible RV sites available?",
    a: "Yes. Accessible sites with asphalt parking pads are available. Guests with specific accessibility needs should contact Auburn RV Resort for assistance.",
  },
];

export const accommodationGallery = [
  {
    id: "ag1",
    src: images.sitePullthrough,
    alt: "Pull-through RV site with full hookups at Auburn RV Resort",
    span: "md:col-span-2 md:row-span-2",
    ratio: "aspect-[16/10]",
  },
  {
    id: "ag2",
    src: images.amenityHookups,
    alt: "Full-hookup RV site with a large motorhome at Auburn RV Resort",
    span: "",
    ratio: "aspect-[3/4]",
  },
  {
    id: "ag3",
    src: images.siteBackin,
    alt: "Aerial view of back-in RV sites and site spacing at Auburn RV Resort",
    span: "",
    ratio: "aspect-[3/4]",
  },
  {
    id: "ag4",
    src: galleryPicnicAsset.url,
    alt: "Picnic table beside an RV site at Auburn RV Resort",
    span: "",
    ratio: "aspect-[4/3]",
  },
  {
    id: "ag5",
    src: images.siteAccessible,
    alt: "Accessible asphalt RV site at Auburn RV Resort",
    span: "md:row-span-2",
    ratio: "aspect-[3/4]",
  },
  {
    id: "ag6",
    src: galleryCampgroundAsset.url,
    alt: "Campground aerial showing trees and RV sites in the Auburn Sierra Foothills",
    span: "md:col-span-2",
    ratio: "aspect-[16/9]",
  },
  {
    id: "ag7",
    src: images.slider4,
    alt: "Wide view of Auburn RV Resort grounds with oak trees and spacious sites",
    span: "",
    ratio: "aspect-[4/3]",
  },
];

export const stayOptions = [
  {
    id: "daily",
    label: "Daily",
    copy: "Ideal for overnight visits, road trips and weekend adventures.",
    cta: "View Daily Rates",
    href: "/rates/#daily",
  },
  {
    id: "weekly",
    label: "Weekly",
    copy: "More time to explore Auburn and the Sierra Foothills.",
    cta: "View Weekly Rates",
    href: "/rates/#weekly",
  },
  {
    id: "monthly",
    label: "Monthly",
    copy: "A comfortable home base for extended stays.",
    cta: "View Monthly Rates",
    href: "/rates/#monthly",
  },
];

export const publishedRates = {
  daily: { from: "$85", unit: "per night", label: "Daily" },
  weekly: { from: "$504", unit: "per week", label: "Weekly" },
  monthly: { from: "$1,260", unit: "per month", label: "Monthly" },
  occupancyIncluded: 4,
  additionalGuestFee: "$5",
  maxOccupancy: 6,
  serviceDeposit: "$250",
  paymentMethods: ["Visa", "Mastercard"] as const,
};

export const rateSummaryCards = [
  {
    id: "daily",
    label: "Daily",
    from: "$85",
    copy: "Short stays & road trips",
  },
  {
    id: "weekly",
    label: "Weekly",
    from: "$504",
    copy: "Explore the Sierra Foothills",
  },
  {
    id: "monthly",
    label: "Monthly",
    from: "$1,260",
    copy: "Extended stays",
  },
];

export const dailyRateFeatures = [
  "Full hookup sites",
  "20 / 30 / 50 amp service",
  "Complimentary WiFi",
  "Water & sewer",
  "Access to resort amenities",
  "Sierra Foothills location",
] as const;

export type RateIncludeIcon = "hookups" | "power" | "wifi" | "amenities" | "sites" | "location";

export const rateIncludes: {
  id: string;
  title: string;
  copy: string;
  icon: RateIncludeIcon;
}[] = [
  {
    id: "hookups",
    title: "Full Hookups",
    copy: "Water and sewer connections.",
    icon: "hookups",
  },
  {
    id: "power",
    title: "Electric Service",
    copy: "20 / 30 / 50 amp service available.",
    icon: "power",
  },
  {
    id: "wifi",
    title: "WiFi",
    copy: "Complimentary WiFi.",
    icon: "wifi",
  },
  {
    id: "amenities",
    title: "Resort Amenities",
    copy: "Access to available Auburn RV Resort guest amenities.",
    icon: "amenities",
  },
  {
    id: "sites",
    title: "Flexible Site Options",
    copy: "Pull-through, back-in and accessible options subject to availability.",
    icon: "sites",
  },
  {
    id: "location",
    title: "Great Location",
    copy: "A convenient home base for exploring Auburn and the Sierra Foothills.",
    icon: "location",
  },
];

export const rateComparison = [
  {
    id: "daily",
    label: "Daily",
    from: "$85",
    bestFor: ["Overnight stays", "Road trips", "Weekend visits", "Short Auburn adventures"],
    cta: "Check Daily",
  },
  {
    id: "weekly",
    label: "Weekly",
    from: "$504",
    bestFor: ["Vacations", "Sierra Foothills exploration", "Longer road trips", "Week-long stays"],
    cta: "Check Weekly",
    featured: true,
  },
  {
    id: "monthly",
    label: "Monthly",
    from: "$1,260",
    bestFor: ["Extended stays", "Longer-term Auburn visits", "Month-to-month guests"],
    cta: "Ask About Monthly",
  },
];

export const extendedStaySteps = [
  {
    step: "1",
    title: "Check Availability",
    copy: "Contact Auburn RV Resort to ask about current extended-stay availability.",
    note: "A waitlist may be in place.",
  },
  {
    step: "2",
    title: "Complete Your Application",
    copy: "Guests seeking an extended stay will be required to complete an application.",
  },
  {
    step: "3",
    title: "Screening",
    copy: "A credit report and background check may be required before an application is approved.",
  },
  {
    step: "4",
    title: "Secure Your Reservation",
    copy: "Once the application is approved, guests must provide the first month's rent and a $250 service deposit.",
    note: "The first month's rent payment is non-refundable. If a confirmed extended-stay reservation is cancelled, that first month's payment is forfeited.",
  },
  {
    step: "5",
    title: "Begin Your Month-to-Month Stay",
    copy: "Extended-stay guests will sign the Monthly Rental Agreement and follow Auburn RV Resort Rules & Regulations.",
    note: "Sites remain month-to-month only. No permanent or yearly sites are offered.",
  },
];

export const rateFaqs = [
  {
    q: "What are the daily rates at Auburn RV Resort?",
    a: "Daily RV site rates currently start at $85. Exact pricing varies by site size, location and availability.",
  },
  {
    q: "What are the weekly rates?",
    a: "Weekly stays currently start at $504. Pricing varies depending on site size, location and availability.",
  },
  {
    q: "What are the monthly rates?",
    a: "Monthly RV sites currently start at $1,260. Extended-stay sites are limited, month-to-month and may require an application and screening process.",
  },
  {
    q: "How many guests are included in the site rate?",
    a: "Published rates include up to four guests.",
  },
  {
    q: "Can I add more guests?",
    a: "Yes. Additional guests are $5 per person, per day, with a maximum total occupancy of six guests per lot.",
  },
  {
    q: "Does Auburn RV Resort offer yearly sites?",
    a: "No. Extended stays are offered on a month-to-month basis only. Permanent and yearly sites are not available.",
  },
  {
    q: "Is electricity included in monthly rates?",
    a: "Extended-stay electrical charges are based on actual usage and vary by month.",
  },
  {
    q: "Is there a deposit for extended stays?",
    a: "Yes. Extended-stay guests are required to provide a $250 service deposit, which is applied toward the final electrical bill. Any unused balance is refunded.",
  },
  {
    q: "Does being on the monthly waitlist guarantee a site?",
    a: "No. Placement on an extended-stay waitlist does not guarantee that a site will become available.",
  },
  {
    q: "What credit cards do you accept?",
    a: "Auburn RV Resort accepts Visa and Mastercard for credit card payments.",
  },
  {
    q: "Is public RV dumping available?",
    a: "No. The on-site dumping facility is for Auburn RV Resort guests only.",
  },
];

export type AmenityQuickIcon = "laundry" | "showers" | "pets" | "wifi" | "outdoor";

export const amenityQuickBar: {
  id: string;
  title: string;
  label: string;
  icon: AmenityQuickIcon;
}[] = [
  { id: "laundry", title: "Laundry", label: "On Site", icon: "laundry" },
  { id: "showers", title: "Showers", label: "Bath & Shower Facilities", icon: "showers" },
  { id: "pets", title: "Pet Friendly", label: "Dog Park + Wash Station", icon: "pets" },
  { id: "wifi", title: "WiFi", label: "Stay Connected", icon: "wifi" },
  { id: "outdoor", title: "Outdoor", label: "Picnic + BBQ", icon: "outdoor" },
];

export type PageAmenityIcon = "laundry" | "showers" | "dogpark" | "dogwash" | "picnic" | "wifi";

export const amenitiesAtAGlance: {
  id: string;
  title: string;
  copy: string;
  icon: PageAmenityIcon;
}[] = [
  {
    id: "laundry",
    title: "On-Site Laundry",
    copy: "Convenient laundry facilities available within the resort.",
    icon: "laundry",
  },
  {
    id: "showers",
    title: "Bath & Showers",
    copy: "Facilities to freshen up during your stay.",
    icon: "showers",
  },
  {
    id: "dogpark",
    title: "Fenced Dog Park",
    copy: "A dedicated outdoor space for traveling pets.",
    icon: "dogpark",
  },
  {
    id: "dogwash",
    title: "Dog Wash Station",
    copy: "Clean up your pet after outdoor adventures.",
    icon: "dogwash",
  },
  {
    id: "picnic",
    title: "Picnic & BBQ",
    copy: "Outdoor spaces for meals and relaxing.",
    icon: "picnic",
  },
  {
    id: "wifi",
    title: "WiFi",
    copy: "Complimentary connectivity for resort guests.",
    icon: "wifi",
  },
];

export const amenityDayTimeline = [
  {
    id: "morning",
    label: "Morning",
    title: "Start Slow",
    copy: "Enjoy coffee outside at your picnic table and plan your day in Auburn.",
  },
  {
    id: "afternoon",
    label: "Afternoon",
    title: "Go Explore",
    copy: "Head out to discover Auburn, the American River, Gold Country or Sierra Foothill trails.",
  },
  {
    id: "evening",
    label: "Evening",
    title: "Come Back & Reset",
    copy: "Freshen up in the bath and shower facilities, take care of laundry and let your dog stretch at the fenced dog park.",
  },
  {
    id: "dinner",
    label: "Dinner",
    title: "Enjoy the Outdoors",
    copy: "Use the BBQ area and wind down after another day of adventure.",
  },
];

export const amenitySiteCards = [
  {
    id: "pull-through",
    title: "Pull-Through",
    copy: "Easy arrivals and departures.",
    image: images.sitePullthrough,
    href: "/accommodations/#pull-through",
  },
  {
    id: "back-in",
    title: "Back-In",
    copy: "Flexible site sizes for a variety of RVs.",
    image: images.siteBackin,
    href: "/accommodations/#back-in",
  },
  {
    id: "accessible",
    title: "Accessible",
    copy: "Asphalt-pad accessible sites.",
    image: images.siteAccessible,
    href: "/accommodations/#accessible",
  },
];

export const amenitiesGallery = [
  {
    id: "amg1",
    src: images.amenityLaundry,
    alt: "On-site laundry facilities at Auburn RV Resort",
    span: "md:col-span-2 md:row-span-2",
    ratio: "aspect-[16/10]",
  },
  {
    id: "amg2",
    src: images.amenityBathhouse,
    alt: "Bath and shower facilities at Auburn RV Resort",
    span: "",
    ratio: "aspect-[3/4]",
  },
  {
    id: "amg3",
    src: images.amenityPets,
    alt: "Fenced dog park with shade trees at Auburn RV Resort",
    span: "",
    ratio: "aspect-[3/4]",
  },
  {
    id: "amg4",
    src: galleryPicnicAsset.url,
    alt: "Picnic table beside an RV site at Auburn RV Resort",
    span: "",
    ratio: "aspect-[4/3]",
  },
  {
    id: "amg5",
    src: images.amenityOutdoor,
    alt: "BBQ grill and outdoor cooking area at Auburn RV Resort",
    span: "md:row-span-2",
    ratio: "aspect-[3/4]",
  },
  {
    id: "amg6",
    src: images.slider4,
    alt: "Resort atmosphere with oak trees and RV sites at Auburn RV Resort",
    span: "md:col-span-2",
    ratio: "aspect-[16/9]",
  },
  {
    id: "amg7",
    src: galleryBathhouseAsset.url,
    alt: "Clean bathhouse exterior at Auburn RV Resort",
    span: "",
    ratio: "aspect-[4/3]",
  },
];

export const amenityFaqs = [
  {
    q: "Does Auburn RV Resort have WiFi?",
    a: "Yes. Complimentary WiFi is available for Auburn RV Resort guests.",
  },
  {
    q: "Does Auburn RV Resort have laundry facilities?",
    a: "Yes. On-site laundry facilities are available during your stay.",
  },
  {
    q: "Are showers available?",
    a: "Yes. Auburn RV Resort offers bath and shower facilities for guests.",
  },
  {
    q: "Is Auburn RV Resort pet friendly?",
    a: "Yes. Auburn RV Resort is pet friendly and offers a fenced dog park and dog wash station.",
  },
  {
    q: "Is there a dog park?",
    a: "Yes. A fenced dog park is available for guests traveling with pets.",
  },
  {
    q: "Is there a place to wash my dog?",
    a: "Yes. Auburn RV Resort provides a dog wash station.",
  },
  {
    q: "Are picnic tables available?",
    a: "Yes. Outdoor picnic tables are available for guests.",
  },
  {
    q: "Is there a BBQ area?",
    a: "Yes. Auburn RV Resort has a designated BBQ area for guests.",
  },
  {
    q: "Are stores and businesses nearby?",
    a: "Auburn RV Resort is located a short drive from shopping, local services and businesses in Auburn.",
  },
];

export const destinationCategories = [
  "All",
  "Local Auburn",
  "Outdoors",
  "Gold Country",
  "Food & Drink",
  "Mountains",
  "Day Trips",
] as const;

export type DestinationCategory = (typeof destinationCategories)[number];

export type DestinationAttraction = {
  id: string;
  name: string;
  category: Exclude<DestinationCategory, "All">;
  location: string;
  description: string;
  image: string;
  alt: string;
  tags: string[];
  cta: string;
  headline?: string;
  note?: string;
  featured?: boolean;
  /** Reserved for verified routing data */
  distance?: string;
  driveTime?: string;
  coordinates?: { lat: number; lng: number };
  website?: string;
  directionsUrl?: string;
};

export const destinations: DestinationAttraction[] = [
  {
    id: "downtown-auburn",
    name: "Downtown Auburn",
    category: "Local Auburn",
    location: "Auburn, CA",
    description:
      "Discover Auburn's historic character, independent shops, restaurants and local atmosphere while exploring the heart of the community.",
    image: advExplore,
    alt: "Historic Downtown Auburn California storefronts and Gold Country architecture",
    tags: ["Historic", "Dining", "Shopping"],
    cta: "Explore Downtown",
    featured: true,
  },
  {
    id: "highway-49",
    name: "Historic Highway 49",
    category: "Gold Country",
    location: "California Gold Country",
    description:
      "Turn the drive itself into an adventure along one of California Gold Country's signature routes, connecting historic foothill communities, mountain scenery and reminders of the state's Gold Rush past.",
    image: advExplore,
    alt: "Scenic California Gold Country highway through the Sierra Foothills",
    tags: ["Scenic Drive", "History", "Gold Country"],
    cta: "Discover Highway 49",
    featured: true,
  },
  {
    id: "empire-mine",
    name: "Empire Mine State Historic Park",
    category: "Gold Country",
    location: "Grass Valley, CA",
    description:
      "Explore an important piece of California mining history in Grass Valley through historic structures, exhibits and the preserved landscape of one of the region's best-known mining sites.",
    image: advExplore,
    alt: "Historic mining landscape associated with Empire Mine State Historic Park",
    tags: ["History", "State Park", "Gold Rush"],
    cta: "Explore Empire Mine",
  },
  {
    id: "marshall-gold",
    name: "Marshall Gold Discovery State Historic Park",
    category: "Gold Country",
    location: "Coloma, California",
    description:
      "Visit the Coloma landscape associated with the 1848 discovery that helped ignite the California Gold Rush and explore an important chapter of California history.",
    image: advHike,
    alt: "Coloma California landscape associated with Marshall Gold Discovery State Historic Park",
    tags: ["California History", "Gold Rush", "Family Adventure"],
    cta: "Discover Coloma",
    featured: true,
  },
  {
    id: "grass-valley-nevada-city",
    name: "Historic Grass Valley & Nevada City",
    category: "Gold Country",
    location: "Nevada County, CA",
    description:
      "Spend a day exploring two distinctive Gold Country communities filled with historic architecture, local shops, restaurants and foothill character.",
    image: advExplore,
    alt: "Historic Gold Country town architecture near Grass Valley and Nevada City",
    tags: ["Historic Towns", "Shopping", "Dining"],
    cta: "Plan a Gold Country Day",
  },
  {
    id: "whitewater-rafting",
    name: "Whitewater Rafting",
    category: "Outdoors",
    location: "American River Region",
    headline: "Take on the River",
    description:
      "For travelers looking for a more energetic adventure, the surrounding region offers seasonal opportunities for guided river experiences and whitewater rafting.",
    note: "Always use qualified outfitters and confirm current river conditions, seasonality and availability before planning your trip.",
    image: advRafting,
    alt: "Whitewater rafting on a Northern California river near Auburn",
    tags: ["Adventure", "Water", "Seasonal"],
    cta: "Explore River Adventures",
    featured: true,
  },
  {
    id: "wings-grill",
    name: "Wings Grill & Espresso Bar",
    category: "Local Auburn",
    location: "Auburn Municipal Airport",
    description:
      "Add a unique local stop to your Auburn itinerary with a casual meal near the action at Auburn Municipal Airport.",
    image: advExplore,
    alt: "Local Auburn dining experience near Auburn Municipal Airport",
    tags: ["Local", "Dining", "Aviation"],
    cta: "Explore Local Auburn",
  },
  {
    id: "sacramento",
    name: "Sacramento",
    category: "Day Trips",
    location: "California's Capital",
    description:
      "Spend a day discovering California's capital region, including historic districts, dining, cultural attractions and the Old Sacramento waterfront area.",
    image: advExplore,
    alt: "Sacramento California capital region day-trip destination",
    tags: ["Day Trip", "History", "Culture"],
    cta: "Plan a Sacramento Day",
  },
  {
    id: "foothills-wineries",
    name: "Sierra Foothills Wineries",
    category: "Food & Drink",
    location: "Sierra Foothills",
    headline: "Sip Something Local",
    description:
      "California wine country stretches well beyond Napa. Explore wineries and vineyard experiences throughout the Sierra Foothills and discover another side of Gold Country.",
    note: "Plan transportation responsibly when visiting tasting rooms and wineries.",
    image: advSip,
    alt: "Sierra Foothills vineyard rows and wine country scenery near Auburn",
    tags: ["Wine", "Scenic", "Adults"],
    cta: "Explore Wine Country",
    featured: true,
  },
  {
    id: "auburn-breweries",
    name: "Auburn Breweries",
    category: "Food & Drink",
    location: "Auburn, CA",
    headline: "Raise a Glass to Auburn",
    description:
      "Discover Auburn's local beer scene and combine a relaxed meal or tasting experience with a day exploring the surrounding foothills.",
    note: "Plan transportation responsibly when enjoying local beer and dining.",
    image: advSip,
    alt: "Local Auburn California brewery and dining atmosphere",
    tags: ["Craft Beer", "Dining", "Local"],
    cta: "Explore Local Flavor",
  },
  {
    id: "hiking",
    name: "Sierra Foothills Hiking",
    category: "Outdoors",
    location: "Auburn & Sierra Foothills",
    headline: "Find Your Trail",
    description:
      "The Auburn area and Sierra Foothills offer a broad range of outdoor landscapes for hikers looking for river scenery, foothill terrain and time in nature.",
    note: "Trail conditions, access and seasonal restrictions can change. Confirm current conditions before heading out.",
    image: advHike,
    alt: "Hiking trail through the Sierra Foothills near Auburn California",
    tags: ["Hiking", "Nature", "Views"],
    cta: "Explore the Trails",
    featured: true,
  },
  {
    id: "mountain-biking",
    name: "Mountain Biking",
    category: "Outdoors",
    location: "Auburn Area Trails",
    headline: "Ride the Foothills",
    description:
      "Auburn's outdoor culture makes the surrounding area an exciting base for riders seeking mountain and foothill trail experiences across different skill levels.",
    image: advRide,
    alt: "Mountain biking trail through golden Sierra Foothills near Auburn",
    tags: ["Cycling", "Trails", "Adventure"],
    cta: "Find Your Ride",
    featured: true,
  },
  {
    id: "donner-summit",
    name: "Donner Summit",
    category: "Mountains",
    location: "Truckee Region",
    headline: "Head for the Mountains",
    description:
      "Turn your Auburn stay into a mountain day trip and discover dramatic Sierra scenery, historic routes and seasonal outdoor recreation around Donner Summit and the Truckee region.",
    note: "Seasonal conditions vary. Verify current road, weather and recreation information before traveling into the mountains.",
    image: advEscape,
    alt: "Sierra Nevada mountain scenery near Donner Summit",
    tags: ["Mountains", "Winter", "Scenic Drive"],
    cta: "Explore the Sierra",
  },
  {
    id: "lake-tahoe",
    name: "Lake Tahoe",
    category: "Day Trips",
    location: "Sierra Nevada",
    headline: "An Iconic Sierra Day Trip",
    description:
      "Add one of California and Nevada's most celebrated mountain destinations to your itinerary with a scenic day exploring the Lake Tahoe region.",
    note: "Check current road, weather and seasonal conditions before traveling into the mountains.",
    image: advEscape,
    alt: "Lake Tahoe alpine shoreline and Sierra Nevada peaks",
    tags: ["Lake", "Mountains", "Day Trip"],
    cta: "Dream Up a Tahoe Day",
    featured: true,
  },
  {
    id: "ridge-golf",
    name: "The Ridge Golf Course",
    category: "Local Auburn",
    location: "Auburn Area",
    description:
      "Golfers can add a day on the course to an Auburn itinerary while enjoying foothill scenery and a change of pace from hiking and river adventures.",
    image: advHike,
    alt: "Foothill landscape suitable for a local Auburn golf day",
    tags: ["Golf", "Outdoor", "Local"],
    cta: "Explore Local Golf",
  },
  {
    id: "black-oak-golf",
    name: "Black Oak Golf Course",
    category: "Local Auburn",
    location: "Placer County",
    description:
      "Another option for guests looking to spend part of their Auburn stay on the greens while enjoying the surrounding Placer County landscape.",
    image: advHike,
    alt: "Placer County foothill landscape near local Auburn golf options",
    tags: ["Golf", "Local", "Recreation"],
    cta: "Explore Local Golf",
  },
];

export const perfectDayExperiences = [
  {
    id: "adventure",
    title: "Adventure Day",
    cta: "I Want Adventure",
    image: advRafting,
    alt: "American River outdoor adventure near Auburn RV Resort",
    beats: [
      { when: "Morning", what: "Hiking" },
      { when: "Afternoon", what: "American River adventure" },
      { when: "Evening", what: "Relax back at Auburn RV Resort" },
    ],
  },
  {
    id: "gold-country",
    title: "Gold Country Day",
    cta: "Explore Gold Country",
    image: advExplore,
    alt: "Historic Gold Country architecture near Auburn California",
    beats: [
      { when: "Morning", what: "Historic Auburn" },
      { when: "Afternoon", what: "Coloma or another Gold Country destination" },
      { when: "Evening", what: "Dinner in the foothills" },
    ],
  },
  {
    id: "food-drink",
    title: "Food & Drink Day",
    cta: "Taste the Foothills",
    image: advSip,
    alt: "Sierra Foothills wine and local flavor experience",
    beats: [
      { when: "Morning", what: "Explore Auburn" },
      { when: "Afternoon", what: "Sierra Foothills winery or local food experience" },
      { when: "Evening", what: "Return to your RV site" },
    ],
  },
  {
    id: "mountain",
    title: "Mountain Day",
    cta: "Head for the Mountains",
    image: advEscape,
    alt: "Sierra Nevada mountain day trip from Auburn",
    beats: [
      { when: "Morning", what: "Head east toward the Sierra" },
      { when: "Day", what: "Explore a mountain destination" },
      { when: "Evening", what: "Return to your Auburn base camp" },
    ],
  },
];

export const outdoorAdventurePanels = [
  {
    id: "hike",
    word: "Hike",
    sub: "Sierra Foothill Trails",
    image: advHike,
    alt: "Hiking trail through the Sierra Foothills near Auburn",
  },
  {
    id: "ride",
    word: "Ride",
    sub: "Mountain Biking",
    image: advRide,
    alt: "Mountain biking in the Auburn Sierra Foothills",
  },
  {
    id: "raft",
    word: "Raft",
    sub: "River Adventures",
    image: advRafting,
    alt: "River adventure near Auburn California",
  },
  {
    id: "climb",
    word: "Climb",
    sub: "Into the Sierra",
    image: advEscape,
    alt: "Sierra Nevada peaks rising above alpine landscape",
  },
  {
    id: "return",
    word: "Return",
    sub: "Your Auburn Base Camp",
    image: images.heroResort,
    alt: "Auburn RV Resort base camp after a day of adventure",
  },
];

export const destinationGallery = [
  {
    id: "dg1",
    src: advExplore,
    alt: "Historic Downtown Auburn California",
    span: "md:col-span-2 md:row-span-2",
    ratio: "aspect-[16/10]",
  },
  {
    id: "dg2",
    src: advRafting,
    alt: "American River whitewater near Auburn",
    span: "",
    ratio: "aspect-[3/4]",
  },
  {
    id: "dg3",
    src: advHike,
    alt: "Sierra Foothills hiking near Auburn California",
    span: "",
    ratio: "aspect-[3/4]",
  },
  {
    id: "dg4",
    src: advRide,
    alt: "Mountain biking trails near Auburn",
    span: "",
    ratio: "aspect-[4/3]",
  },
  {
    id: "dg5",
    src: advSip,
    alt: "Sierra Foothills wine country scenery",
    span: "md:row-span-2",
    ratio: "aspect-[3/4]",
  },
  {
    id: "dg6",
    src: advEscape,
    alt: "Lake Tahoe and Sierra Nevada day-trip scenery",
    span: "md:col-span-2",
    ratio: "aspect-[16/9]",
  },
  {
    id: "dg7",
    src: images.storyDetail,
    alt: "American River emerald water near Auburn",
    span: "",
    ratio: "aspect-[4/3]",
  },
  {
    id: "dg8",
    src: images.slider4,
    alt: "Sierra Foothills landscape surrounding Auburn RV Resort",
    span: "",
    ratio: "aspect-[4/3]",
  },
];

/** Approved pet policy text from Auburn RV Resort (preserve legal meaning). */
export const petPolicyText = `The types of pets permitted are: a domestic bird, cat, dog, or aquatic animal kept within an aquarium. Guide dogs, signal dogs and other service dogs as defined by Civil Code 54.1 are exempt from the size limitation otherwise applicable to dogs. Prohibited animals: Pitbulls, pitbull mix, chows, Rottweilers, Doberman pinschers, Doberman pinscher mix, miniature Doberman pinschers, Boston Terriers, Wolfhounds, Wolf Hybrids, dingoes, German Shepherds, Bull Terriers, Great Danes, mastiffs, Boston Bull Terriers, Pugs, American Bulldog, Presa Canario, Akitas, Alaskan Malamute, Siberian Huskies, and other aggressive breeds are expressly prohibited. Non-house pets (including farm animals) are prohibited under any circumstances.`;

export const reservationFaqs = [
  {
    q: "Does submitting this form confirm my reservation?",
    a: "No. This form is an availability request. Auburn RV Resort must review your information and confirm availability separately.",
  },
  {
    q: "When will Auburn RV Resort contact me?",
    a: "The resort states that it will reach out within 48 hours after receiving your availability request.",
  },
  {
    q: "Can I request a monthly stay?",
    a: "Yes. Monthly / extended-stay requests are accepted, but availability may be limited and additional application requirements may apply.",
  },
  {
    q: "Is there a maximum number of guests?",
    a: "Published rates include up to four guests. Additional guests can be added for $5 per person per day, up to six guests total per site.",
  },
  {
    q: "Can I bring pets?",
    a: "Auburn RV Resort is pet friendly subject to its existing pet policy. Review the pet policy during the availability request process.",
  },
  {
    q: "Does Auburn RV Resort accept credit cards?",
    a: "Visa and Mastercard are accepted for credit card payments.",
  },
  {
    q: "Do I pay through this form?",
    a: "No. This form collects an availability request only and should not collect payment card information.",
  },
];

export const mapQuickStats = [
  { value: "71", label: "RV Sites" },
  { value: "10", label: "Pull-Through Sites" },
  { value: "120 FT", label: "Sites Up To" },
  { value: "20 / 30 / 50 AMP", label: "Electrical Service" },
];

export const mapSiteTypeCards = [
  {
    id: "pull-through",
    kicker: "Pull-Through",
    headline: "Easy In. Easy Out.",
    copy: "Auburn RV Resort offers 10 pull-through sites ranging from approximately 44 to 120 feet, making them a convenient option for many larger rigs and guests who prefer easier arrival and departure.",
    cta: "Explore Pull-Through Sites",
    href: "/accommodations/#pull-through",
    image: images.sitePullthrough,
    alt: "Spacious pull-through RV site at Auburn RV Resort",
  },
  {
    id: "back-in",
    kicker: "Back-In",
    headline: "Settle In & Stay Awhile",
    copy: "Back-in sites range from approximately 36 feet to more than 120 feet and are available for daily, weekly and monthly stays.",
    cta: "Explore Back-In Sites",
    href: "/accommodations/#back-in",
    image: images.siteBackin,
    alt: "Back-in RV sites and resort grounds at Auburn RV Resort",
  },
  {
    id: "accessible",
    kicker: "Accessible",
    headline: "Comfortable & Convenient",
    copy: "Accessible sites with asphalt parking pads are available for guests who require them.",
    cta: "Ask About Accessible Sites",
    href: "/reservations/",
    image: images.siteAccessible,
    alt: "Accessible RV site with asphalt pad at Auburn RV Resort",
  },
];

export const mapHookupHighlights = [
  { id: "water", title: "Water", icon: "water" as const },
  { id: "sewer", title: "Sewer", icon: "sewer" as const },
  { id: "power", title: "20 / 30 / 50 Amp", icon: "power" as const },
  { id: "wifi", title: "WiFi", icon: "wifi" as const },
  { id: "picnic", title: "Picnic Table", icon: "picnic" as const },
];

export const mapAmenityPreviews = [
  { label: "On-site laundry", image: images.amenityLaundry, alt: "On-site laundry facilities at Auburn RV Resort" },
  { label: "Bath & shower facilities", image: images.amenityBathhouse, alt: "Bath and shower facilities at Auburn RV Resort" },
  { label: "Fenced dog park", image: images.amenityPets, alt: "Fenced dog park at Auburn RV Resort" },
  { label: "Dog wash station", image: images.amenityPets, alt: "Pet-friendly amenities including dog wash area" },
  { label: "Picnic areas", image: galleryPicnicAsset.url, alt: "Picnic table beside an RV site" },
  { label: "BBQ area", image: images.amenityOutdoor, alt: "BBQ grill and outdoor cooking area" },
  { label: "WiFi", image: images.amenityHookups, alt: "Full hookup RV site with WiFi access" },
];

export const contactFaqs = [
  {
    q: "What is Auburn RV Resort's phone number?",
    a: "You can call Auburn RV Resort at 530-889-8878.",
  },
  {
    q: "What is the resort's email address?",
    a: "The resort can be reached at auburnrvresort@gmail.com.",
  },
  {
    q: "Where is Auburn RV Resort located?",
    a: "Auburn RV Resort is located at 14400 Musso Road, Auburn, CA 95603.",
  },
  {
    q: "Can I make a reservation through this contact form?",
    a: "No. Guests looking for an RV site should use the Availability Request form so Auburn RV Resort can collect the information needed to review the stay.",
  },
  {
    q: "Does submitting an Availability Request guarantee a reservation?",
    a: "No. Availability requests are reviewed manually by Auburn RV Resort and do not guarantee a site or reservation.",
  },
];

export const contactQuickLinks = [
  {
    id: "sites",
    title: "Find an RV Site",
    copy: "Explore pull-through, back-in and accessible RV accommodations.",
    cta: "View Accommodations",
    href: "/accommodations/",
    emphasis: false,
  },
  {
    id: "rates",
    title: "View Pricing",
    copy: "Compare daily, weekly and monthly starting rates.",
    cta: "View Rates",
    href: "/rates/",
    emphasis: false,
  },
  {
    id: "availability",
    title: "Request Availability",
    copy: "Tell us your dates and RV details so our team can review your request.",
    cta: "Check Availability",
    href: "/reservations/",
    emphasis: true,
  },
  {
    id: "explore",
    title: "Explore Auburn",
    copy: "Discover outdoor adventures, Gold Country and nearby attractions.",
    cta: "Explore the Area",
    href: "/nearby-attractions/",
    emphasis: false,
  },
];

export const mapFaqs = [
  {
    q: "Can I choose a specific RV site from the map?",
    a: "The map helps guests understand the Auburn RV Resort layout, but individual site availability and assignments are confirmed by resort staff.",
  },
  {
    q: "Does viewing a site on the map mean it is available?",
    a: "No. The map is informational and does not display live inventory.",
  },
  {
    q: "How many RV sites does Auburn RV Resort have?",
    a: "Auburn RV Resort has 71 RV sites in varying sizes.",
  },
  {
    q: "Are pull-through sites available?",
    a: "Yes. The resort has 10 pull-through sites ranging from approximately 44 to 120 feet.",
  },
  {
    q: "Are larger RVs accommodated?",
    a: "Many sites range from approximately 44 to 120 feet and may accommodate larger RVs. Guests should provide their RV length when requesting availability so the resort can help identify a suitable option.",
  },
  {
    q: "Can I request a particular part of the resort?",
    a: "Guests may provide site preferences in their availability request, but specific site placement is subject to availability and confirmation by Auburn RV Resort.",
  },
  {
    q: "How do I check availability?",
    a: "Use the Check Availability form and provide your dates, party information and RV details. Auburn RV Resort will review the request and contact you.",
  },
];

export const destinationFaqs = [
  {
    q: "What are some things to do near Auburn RV Resort?",
    a: "Guests can explore historic Auburn, Sierra Foothills outdoor recreation, Gold Country destinations, local food and drink experiences and regional day-trip destinations.",
  },
  {
    q: "Are there hiking opportunities near Auburn?",
    a: "Yes. Auburn and the surrounding Sierra Foothills are known for outdoor recreation and trail experiences. Always check current trail access and conditions before visiting.",
  },
  {
    q: "Can I go whitewater rafting near Auburn?",
    a: "The broader American River region is known for seasonal whitewater recreation. Guests interested in rafting should use qualified outfitters and confirm current conditions and availability.",
  },
  {
    q: "Are there Gold Rush attractions near Auburn?",
    a: "Yes. California Gold Country includes historic towns, Highway 49 and state historic sites connected with the region's mining history.",
  },
  {
    q: "Are there wineries near Auburn?",
    a: "The Sierra Foothills include wineries and vineyard experiences throughout the region.",
  },
  {
    q: "Are there breweries in Auburn?",
    a: "Auburn and the surrounding area include local beer and dining options.",
  },
  {
    q: "Can I visit Lake Tahoe while staying at Auburn RV Resort?",
    a: "Lake Tahoe can be incorporated into a broader Sierra itinerary from Auburn. Guests should check current road, weather and seasonal conditions before traveling into the mountains.",
  },
  {
    q: "Are there winter activities nearby?",
    a: "The Sierra and Donner Summit region offers seasonal mountain recreation. Conditions and availability vary, so guests should verify current information before departing.",
  },
  {
    q: "What should I do before visiting outdoor attractions?",
    a: "Check current weather, road conditions, trail access, river conditions, seasonal closures and individual attraction information before leaving the resort.",
  },
];
